import * as React from "react";

import { cn } from "@/shared/utils/utils";
import type { CustomCardSkeletonProps } from "@/shared/type/skeleton.type";
import { Skeleton } from "./skeleton";

export const CustomCardSkeleton = ({
  className,
  iconClassName,
  subtitleClassName,
  titleClassName,
  ...props
}: CustomCardSkeletonProps): React.ReactElement => (
  <div
    className={cn(
      "card h-full w-full border-none p-4",
      "flex flex-col justify-between",
      className,
    )}
    {...props}
  >
    <Skeleton
      className={cn(
        "ml-auto size-7 max-xs:size-6 max-[480px]:size-7",
        iconClassName,
      )}
    />
    <div className="space-y-2">
      <Skeleton className={cn("h-8 w-20", subtitleClassName)} />
      <Skeleton className={cn("h-4 w-28 max-w-full", titleClassName)} />
    </div>
  </div>
);
